import React, { Component } from 'react';
import MatchHeader from './match-header';
import MatchSummary from './match-summary';
import MatchTeams from './match-teams';
import MatchH2H from './match-h2h';
import MatchForm from './match-form';
import MatchStats from './match-stats';
import MatchTips from './tips';
import { subscribeLivescoreMatch, closeSocket } from '../../utils/web-socket';

class MatchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleSubscribeLivescoreMatch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.gameInfo.match_id !== this.props.gameInfo.match_id) {
      this.handleSubscribeLivescoreMatch();
    }
  }

  componentWillUnmount() {
    closeSocket();
  }

  handleSubscribeLivescoreMatch = () => {
    subscribeLivescoreMatch(
      (err, game) => { this.props.handleLivescores(game) },
      this.props.gameInfo.match_id
    );
  }

  render() {
    return (
      <div className="global">
        <MatchHeader gameInfo={this.props.gameInfo} />
        {
          this.props.gameInfo.tips.length > 0 &&
          <MatchTips data={this.props.gameInfo} />
        }
        {
          this.props.gameInfo.status !== "Postponed" &&
          this.props.gameInfo.status !== "Fixture" &&
          <MatchSummary data={this.props.gameInfo} />
        }
        {
          this.props.gameInfo.statistics.length > 0 &&
          <MatchStats data={this.props.gameInfo} />
        }
        {
          this.props.gameInfo.team_A_formation !== '0-0-0' &&
          this.props.gameInfo.team_B_formation !== '0-0-0' &&
          <MatchTeams data={this.props.gameInfo} />
        }
        {
          this.props.gameInfo.head2head.length > 0 &&
          <MatchH2H data={this.props.gameInfo} />
        }
        {
          this.props.gameInfo.form.length > 0 &&
          <MatchForm data={this.props.gameInfo} />
        }
      </div>
    );
  }
}

export default MatchPage;
